<template>
  <div class="adminairlinemedia">
    <div class="adminairlinemedia__header">
      <div class="adminairlinemedia__header__left">
        <div class="adminairlinemedia__header__left__search">
          <i class="adx-ic_search"></i>
          <input v-model="searchBoxValue" type="text" placeholder="Search">
        </div>
        <adx-dropdown-list class="filter" :color="`pink`" @selected="selectCategory" :loading="isLoadingForm" :valueDisplay="selectedCategory.value" :list="categoryOptions" :labelButton="selectedCategory.label?selectedCategory.label:'Categories'"/>
        <adx-dropdown-list class="filter" :color="`pink`" @selected="selectBrand" :loading="isLoadingForm" :valueDisplay="selectedBrand.value" :list="brandOptions" :labelButton="selectedBrand.label?selectedBrand.label:'Brand'"/>
        <div v-if="filtered" class="reset">
          <button class="btn-regular link" @click="resetFilter">Reset</button>
        </div>
      </div>
      <button class="btn-large primary" @click="addNew">Add New Media</button>
    </div>
    <div class="adminairlinemedia__listing">
      <div  class="tableWrapper">
      <table>
        <thead>
          <tr>
            <td class="col1">Media</td>
            <td class="col2">Placement</td>
            <td class="col2">Owner</td>
            <!-- <td class="col2">Profile</td> -->
            <td class="col3"></td>
          </tr>
        </thead>
        <tbody v-if="!isLoading">
          <tr v-for="(media, index) in medias" :key="index" class="content">
            <td class="col1">
              <div class="mediaGroup">
                <div class="subhead media name">{{media.name}}</div>
                <div class="small-font detail">{{media.detail}}</div>
              </div>
            </td>
            <td v-if="media.placements.length === 0" class="col2"><span>-</span></td>
            <td v-else-if="media.placements.length > 0 && media.placements.length <= 2" class="col2">
              <div v-for="(placement, index) in media.placements" :key="index" class="subhead elipsis">
                {{placement}}
              </div>
            </td>
            <td v-else-if="media.placements.length > 2" class="col2">
              <div :class="[show[index] ? '': 'hidden']">
                <div v-for="(placement, index) in media.placements" :key="index" class="subhead elipsis">
                  {{placement}}
                </div>
              </div>
              <div v-if="!show[index]" class="showButton" @click="showMore(index)">
                <span class="small-font toggleShow">Show More</span>
                <i class="icon-chevrondown"></i>
              </div>
              <div v-else class="showButton" @click="showMore(index)">
                <span class="small-font toggleShow" >Show Less</span>
                <i class="icon-chevronup"></i>
              </div>
            </td>
            <td class="col2"><span class="subhead owner">{{media.owner}}</span></td>
            <!-- <td class="col2"><span class="subhead owner">{{media.profile}}</span></td> -->
            <td class="col3">
              <menu-expansion :lists="media.delete? menuActions: menuActionsNot" @selected="selected($event, media)"/>
            </td>
          </tr>
        </tbody>
      </table>
      </div>

      <div class="emptyState">
        <adx-empty-selection v-if="isEmpty && !isLoading" :title="title"/>
      </div>
      <div v-if="isLoading" class="table__loadingWrapper">
        <slot name="loading" />
        <adx-loading/>
      </div>
      <div class="pagination" v-if="!isLoading && !isEmpty">
        <div class="total" >{{getDataRange}} of {{count}} Medias</div>
        <adx-pagination :selectedPage="selectedPage" :maxPage="maxPage" @change-page="selectPage"/>
      </div>
    </div>
    <adx-modal hideClose="true" v-if="isShowModal" title="Delete Media" type="small">
      <div slot="content" class="adminairlinemedia__modal">
        <div class="adminairlinemedia__modal__top">
          <span>Sure want to delete this media?</span>
        </div>
        <div class="adminairlinemedia__modal__bottom">
          <button class="btn-regular primary" @click="deleteMedia()">Yes<adx-loading-2 class="btn-loading" v-if="isLoadingMutation"/></button>
          <button class="btn-regular secondary" @click="cancelDelete()">Cancel</button>
        </div>
      </div>
    </adx-modal>
  </div>
</template>

<script>

import api from '@/api'
import { AEmptySelection, ALoadingPrimary, ALoadingSecondaryWhite, APagination, AMenuExpansion, AModal, AListDropdown} from "ui-kit-v1"

import { mapGetters } from 'vuex'
import { restEdge } from '@/api/edgeUrls'
import { mapListFilter } from '@/lib/transformer'
import { globalMixins } from "@/lib/mixins/globalMixins"

import * as validationLib from '@/lib/validation/'
const { helpers, } = validationLib;

export default {
  name: 'adx-bus-media',
  components: {
    'adx-modal': AModal,
    'adx-empty-selection': AEmptySelection,
    'adx-loading': ALoadingPrimary,
    'adx-loading-2': ALoadingSecondaryWhite,
    'adx-pagination': APagination,
    'menu-expansion': AMenuExpansion,
    'adx-dropdown-list': AListDropdown,
  },
  mixins: [globalMixins],
  props: {},
  data() {
    return {
      category: null,
      count: 0,
      isEmpty: false,
      isLoadingMain:false,
      isLoadingMutation: false,
      isLoadingForm: false,
      isShowModal: false,
      maxPage: 1,
      searchBoxValue: null,
      selectedBrand: {
        value: null,
        label: null
      },
      selectedCategory: {
        value: null,
        label: null
      },
      selectedMediaId: null,
      selectedPage: 1,
      selectedSortValue: "last_added",
      show: [],
      title: "You dont have any Media here. lets create some !",
      categoryOptions: [],
      brandOptions: [],
      medias: [],
      menuActions: [
        {
          id: 1,
          name: 'Edit Media',
          value: 'editmedia',
        },
        {
          id: 2,
          name: 'Duplicate Media',
          value: 'duplicatemedia'
        },
        {
          id: 3,
          name: 'Delete Media',
          value: 'deletemedia'
        }
      ],
      menuActionsNot: [
        {
          id: 1,
          name: 'Edit Media',
          value: 'editmedia'
        },
        {
          id: 2,
          name: 'Duplicate Media',
          value: 'duplicatemedia'
        },
        {
          id: 3,
          name: 'Delete Media',
          value: 'deletemedia',
          disabled: 'You must remove all placement first.',
          position: 'top'
        }
      ],
    }
  },
  computed: {
    ...mapGetters({
      token: 'token'
    }),
    isLoading: function(){
      return this.isLoadingMain || this.isLoadingMutation || false
    },
    getDataRange: function(){
      let endPage = this.selectedPage * 15;
      return this.count > 15 ? ((endPage < this.count) ? endPage: endPage - 15 + (this.count % 15)) : this.count
    },
    filtered: function() {
      let filtered = false
      if (this.selectedCategory.label || this.selectedBrand.label){
        filtered = true
      }
      return filtered
    },
    getQueryParams(){
      let queryParams = {
        search: this.searchBoxValue != null ? this.searchBoxValue.toString() : undefined,
        category: this.selectedCategory.value != null ? this.selectedCategory.value.toString() : undefined,
        brand: this.selectedBrand.value != null ? this.selectedBrand.value.toString() : undefined,
      }
      return queryParams
    }
  },
  apollo: {

  },
  watch: {
    searchBoxValue: helpers.debounce(function () {
      this.selectedPage = 1;
      this.count = 0;
      this.getMedia()
    }, 500),
    selectedSortValue: function () {
      this.selectedPage = 1;
      this.count = 0;
      this.getMedia()
    },
    selectedPage: function (){
      this.count = 0;
      this.getMedia()
    },
    selectedCategory: function (newValue, oldValue) {
      if (newValue.value !== oldValue.value) {
        this.selectedPage = 1;
        this.selectedCategory = newValue;
        this.count = 0;
        this.getMedia()
      }
    },
    selectedBrand: function (newValue, oldValue) {
      if (newValue.value !== oldValue.value) {
        this.selectedPage = 1;
        this.selectedBrand = newValue;
        this.count = 0;
        this.getMedia()
      }
    },
  },
  beforeCreate() {

  },
  created() {
    localStorage.setItem('apollo-token', this.token);
    this.getMedia();
    this.getListing();
    this.createShowArray()
  },
  beforeMount() {

  },
  mounted() {
    
  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    async getListing(){
      this.isLoadingForm = true
      const response = await api.get(restEdge.airlineMediaFilterListing, {
        needToken: true,
        useRestEdge: true
      });
      if (response.status == 200) {
        this.brandOptions = mapListFilter({obj: response.data.brand, id:`id`, value:`id`, label: `title`})
        this.categoryOptions = mapListFilter({obj: response.data.category, id:`id`, value: `id`, label:`title`})
      }
      this.isLoadingForm = false
    },
    async getMedia(){
      this.isLoadingMain = true;
      const response = await api.get(restEdge.adminAirlineMedia, { needToken: true, useRestEdge: true, params:{page:this.selectedPage, ...this.getQueryParams, sort: this.selectedSortValue}});
      
      if(response.status == 200){
        const {data} = response
        let tmpmedias = []
        data.results.map( media => {
          tmpmedias.push({
            id: media.id,
            name: media.name,
            detail: media.airlinesCategory? media.airlinesCategory.title : '-',
            placements: this.processedPlacement(media.airlinesPlacement),
            owner: media.owner? media.owner.email : '-',
            profile: media.profile? media.profile.title : '-',
            delete: !media.airlinesPlacement.length
          })
        });
        this.medias = await tmpmedias;
        this.maxPage = data.maxPage;
        // this.maxPage = 2
        this.count = data.count
        this.isEmpty = this.medias.length === 0;
        this.isLoadingMain = false;
      } else {
        this.showNotificationAlert("Error", "Data failed to load!", "danger");
        this.isLoadingMain = false;
        this.isEmpty = true
        console.log(`error`)
      }
    },
    addNew() {
      this.$router.push({name: 'addmediaairline'})
    },
    selected(index, item){
      if(index.value ===  'editmedia'){
        this.$router.push({name: 'editmediaairline',  params: {  id: item.id }})
      } else if (index.value === 'duplicatemedia') {
        this.duplicateMedia(item.id)
      } else if(index.value ===  'deletemedia'){
        if (item.placements && item.placements.length > 0) {
          this.showNotificationAlert("Error", "Media cannot be deleted. You must remove all placement first!", "danger"); 
        } else {
          this.confirmDelete(item.id)
        }
        
      }
    },
    async deleteMedia() {
      this.isLoadingMutation = true;
      const response = await api.destroy(restEdge.adminAirlineMediaDelete(this.selectedMediaId), { needToken: true, useRestEdge: true,});
      if(response.status == 200) {
        this.toggleModal();
        this.getMedia();
        this.isLoadingMutation = false;
        this.showNotificationAlert("Success", "Data successfully deleted!", "success");
      } else {
        this.toggleModal();
        this.getMedia();
        this.isLoadingMutation = false;
        this.showNotificationAlert("Error", "Data failed to delete!", "danger");
      }
    },
    confirmDelete(id){
      this.selectedMediaId = id;
      this.toggleModal()
    },
    cancelDelete(){
      this.selectedMediaId = null;
      this.toggleModal()
    },
    async duplicateMedia(id) {
      this.isLoadingMutation = true;
      const response = await api.post(restEdge.adminAirlineMediaDuplicate(id), {}, { needToken: true, useRestEdge: true,});

      if (response.status == 200) {
        this.getMedia();
        this.isLoadingMutation = false;
        this.showNotificationAlert('Success', 'Data successfully duplicated!', 'success')
      } else {
        this.isLoadingMutation = false;
        this.showNotificationAlert('Error', 'Data failed to duplicate!', 'danger')
      }
    },
    toggleModal(){
      this.isShowModal = !this.isShowModal
    },
    showMore(index) {
      // assign array this way to make array change on DOM.
      this.$set(this.show, index, !this.show[index]);
    },
    selectPage(page) {
      this.selectedPage = page;
      this.count = 0;
      this.getMedia()
    },
    processedDetail(array, category) {
      let processed = [];
      if (array){
        array.map(index => {
          processed.push(index.location)
        })
      }
      let processed_mid=[];
      if (processed.length > 3){
        let len = Math.round(processed.length/2);
        processed_mid.push(processed[len-1]);
        processed_mid.push(processed[len]);
        processed_mid.push(processed[len+1])
      } else {
        processed_mid = processed
      }
      let final_process = processed_mid.join(' - ');
      let cat = category? category.title : "";
      return '('+ cat+ ') Via ' + final_process
    },
    processedPlacement(placement) {
      let processed = [];
      if (placement){
        placement.map(ps => {
          processed.push(ps.name)
        })
      }
      return processed
    },
    selectCategory(item){
      this.selectedCategory = item
    },
    selectBrand(item){
      this.selectedBrand = item
    },
    resetFilter() {
      let category = { id:0, label: null, value: null, }
      let brand = { id:0, label: null, value: null, }
      this.selectedCategory = category
      this.selectedBrand = brand
      this.getMedia()
    },
    createShowArray() {
      let i = 0;
      for (i = 0; i < this.medias.length; i++) {
        this.show.push(false)
      }
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>